import React from 'react';
import { Icon } from '../Icon';
import greenWaveSrc from '../../assets/images/slide/green-wave.png';
import styles from './PauseSlideContentV23.css';

function PauseSlideContentV23() {
    return (
        <section className={styles.form}>
            <div className={styles.cards} aria-hidden='true'>
                <div className={styles.card}>
                    <p className={styles.label}>Your input</p>
                    <div className={styles.recorder}>
                        <span className={styles.mic}>
                            <Icon name='mic' className={styles.micIcon} />
                        </span>
                        <img src={greenWaveSrc} alt='' className={styles.wave} />
                    </div>
                </div>
                <p className={styles.pill}>
                    <Icon name='sparkle' className={styles.pillIcon} />
                    Boundly shapes your words
                </p>
                <div className={styles.card}>
                    <div className={styles.storyTop}>
                        <span className={styles.badge}>New story</span>
                        <span className={styles.label}>In your voice</span>
                    </div>
                    <p className={styles.title}>The Bell Over the Door</p>
                    <span className={styles.lines}>
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                    </span>
                </div>
            </div>
            <h2 className={styles.heading}>Tell it the way you’d tell a friend</h2>
            <p className={styles.description}>We ask the questions, so you never have to figure out where to start. Talk or type, a few minutes at a time.</p>
        </section>
    );
}

export {
    PauseSlideContentV23
};
